import React, { useEffect } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Card from "../../../../../../core/Card";
import style from "../../../../../style.module.css";
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useDispatch } from 'react-redux';
import { updateStaticField } from '../../../../../../store/actions/formBuilderAction';
import { useTranslation } from 'react-i18next';

const EditSubmitBtnModal = ({ data, modalOpen, setModalOpen, language_code, survey_id }) => {

    //State
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();
    //Yup
    let shape = {
        label: Yup.string().required('Button text required'),
        alignment: Yup.string().required('Please select button alignment')
    }
    const formSchema = Yup.object().shape(shape)

    //Formik
    let initialValues = {
        label: '',
        alignment: null
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
        onSubmit: (data) => {
            const payload = {
                language_code,
                label: data.label,
                name: 'SUBMIT',
                options: { alignment: data.alignment },
                survey_id
            }
            dispatch(updateStaticField(payload, handleCancel))
        }
    })

    const { values, handleChange, handleBlur, touched, errors, setFieldValue, resetForm, handleSubmit } = formik

    //Functionalities
    const handleCancel = (e) => {
        e?.preventDefault()
        resetForm()
        setModalOpen(false)
    }

    const hanldeChangeAlignment = (value) => {
        setFieldValue('alignment', value)
    }

    //Effects
    useEffect(() => {
        if (data) {
            setFieldValue('label', data?.su_label_and_options && (JSON.parse(data.su_label_and_options)[language_code] ?? ''))
            let alignment = data.su_options && JSON.parse(data.su_options)
            alignment = alignment?.alignment ?? ''
            setFieldValue('alignment', alignment)
        }
    }, [data, modalOpen])

    return (
        <div className={`customvar-modal modal custom-modal fade edit-pop-modal ${modalOpen ? 'show' : ''}`} style={{ display: `${modalOpen ? 'block' : 'none'}` }} id="editButton" tabIndex={-1} aria-labelledby="editButtonLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className={`formcontainer ${style.container}`}>
                                <div className={`formvawrapper modal-edit ${style.wrapper}`}>
                                    <Card view="raised" className={`formstyle p-4 ${style.card}`} >
                                        <div className="edit-field-wrap p-0 mb-4 profile-wrapper form-preview-wrapper">
                                            <h5>{t('survey.builder.editButton')}</h5>
                                            <div className="field-wrap form-wrapper">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="mb-3 position-relative">
                                                            <label htmlFor="">{t('survey.builder.btnText')}</label>
                                                            <Input
                                                                type='text'
                                                                view='outlined'
                                                                dense={false}
                                                                color='default'
                                                                label=''
                                                                success={false}
                                                                error={false}
                                                                fill={true}
                                                                errorHelperText={null}
                                                                className={"formsinput"}
                                                                name='label'
                                                                value={values.label}
                                                                onChange={window.modulePermissions.M12.edit == 1 ? handleChange : undefined}
                                                                onBlur={window.modulePermissions.M12.edit == 1 ? handleBlur : undefined}
                                                                readOnly={window.modulePermissions.M12.edit != 1}
                                                            />
                                                            {touched.label && errors.label && <div className='validation-msg'>{errors.label}</div>}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 alignment-column">
                                                        <div className="mb-3">
                                                            <label htmlFor="">{t('survey.builder.alignment')}</label>

                                                            <div className="dropdown table-dropdown ques-options">
                                                                <button className="btn dropdown-tgl w-100" type="button" id="languages" data-bs-toggle={window.modulePermissions.M12.edit == 1 ? "dropdown" : undefined}
                                                                    aria-haspopup="true" aria-expanded="false" disabled={window.modulePermissions.M12.edit != 1}>
                                                                    <span className='me-2'>{values.alignment ?? 'Select'}</span>
                                                                </button>
                                                                <div className="dropdown-menu" aria-labelledby="languages">
                                                                    <span className="dropdown-item" onClick={() => hanldeChangeAlignment('Center')}>{t('survey.builder.center')}</span>
                                                                    <span className="dropdown-item" onClick={() => hanldeChangeAlignment('Left')}>{t('survey.builder.left')}</span>
                                                                    <span className="dropdown-item" onClick={() => hanldeChangeAlignment('Right')}>{t('survey.builder.right')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                        <div className="button-wrap d-flex justify-content-end">
                                            <button type="button" className="btn btn-bordered" onClick={(e) => handleCancel(e)}>{t('survey.customFormula.cancel')}</button>
                                            {window.modulePermissions.M12.edit == 1 && <button type={t('survey.builder.submit')} className="btn btn-primary ms-4">{t('survey.builder.save')}</button>}
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditSubmitBtnModal